import Vue from "vue";
import App from "./App";
import router from "./router";
import echarts from "echarts";
import SocketService from "@/utils/socket";
// import * as echarts from 'echarts';
import "@/assets/css/reset.css";
// 引入公共echarts公共组件// 引入socket

// const socket = new SocketService('ws://49.4.68.207:5080/websocket')
// export default socket

// SocketService.Instance.connect(); //服务端定义websocket的连接
// Vue.prototype.$socket = SocketService.Instance; //其他组件的调用websoket

Vue.prototype.$echarts = echarts;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js